module.exports = __webpack_public_path__ + "static/media/personalWebsite.a1ab78d5.png";